import React from "react";
import classNames from "classnames";
import StepItem, { StepData } from "./StepItem";

interface Props {
  stepData: ReadonlyArray<StepData>;
  selectStep?: (stepIndex: number) => void;
  color?: string;
  vertical?: boolean;
  solid?: boolean;
}

const StepList: React.FC<Props> = (props: Props): JSX.Element => {
  const { stepData, selectStep, color = "darkblue", vertical, solid } = props;

  const handleClick = (index: number): void => {
    if (selectStep) {
      selectStep(index);
    }
  };

  const steps = stepData.map((step, stepIndex) => {
    const num = stepIndex + 1;

    return <StepItem key={num} data={step} stepNum={num} solid={solid} handleClick={(): void => handleClick(stepIndex)} />;
  });

  const stepsClasses = classNames(
    "caprx-steps",
    `caprx-steps-${color}`,
    { "caprx-steps-vertical": vertical },
    { "caprx-steps-solid": solid },
  );

  return <div className={stepsClasses}>{steps}</div>;
};

export default StepList;
